import { resultsetWithFields, /* formatName */ } from 'vlcishared';
import { TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';
import { CHART_BAR_LINE_TAREAS_AYUNTAMIENTO as baseOptions } from './options-charts';

export function extraerDatosGrafico(datos) {
  const datosConCampos = resultsetWithFields(datos);
  return {
    desagregado: datosConCampos.map((item) => item.desagregado),
    tareasRealizadas: datosConCampos.map((item) => item.tareas_realizadas),
    tareasPendientes: datosConCampos.map((item) => item.tareas_pendientes),
    cargaAdministrativa: datosConCampos.map(
      (item) => item.carga_administrativa,
    ),
  };
}

export function opcionesGraficosActividadComunes(datos) {
  const {
    desagregado,
    tareasRealizadas,
    tareasPendientes,
    cargaAdministrativa,
  } = extraerDatosGrafico(datos);

  const opcionesGrafica = JSON.parse(JSON.stringify(baseOptions));

  opcionesGrafica.xAxis[0].data = desagregado;

  opcionesGrafica.series[0].name =
    TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
      'tareas_realizadas',
    );
  opcionesGrafica.series[0].data = tareasRealizadas;

  opcionesGrafica.series[1].name =
    TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
      'tareas_pendientes',
    );
  opcionesGrafica.series[1].data = tareasPendientes;

  opcionesGrafica.series[2].name = TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[
    DEFAULT_LANGUAGE
  ].get('carga_administrativa');
  opcionesGrafica.series[2].data = cargaAdministrativa;

  opcionesGrafica.tooltip.formatter = function (params) {//
    let textoTooltip = `<b>${params[0].axisValueLabel}</b><br/>`;
    params.forEach((item) => {
      textoTooltip += `${item.marker} ${
        item.seriesName
      }: <b style="font-weight: 600; color: #333;">${item.value.toLocaleString('es-ES')}</b><br/>`;
    });
    return textoTooltip;
  };

  return {
    opcionesGrafica,
    desagregado,
  };
}
